import { render, staticRenderFns } from "./tooltip2.vue?vue&type=template&id=a2335de8&scoped=true&"
import script from "./tooltip2.vue?vue&type=script&lang=js&"
export * from "./tooltip2.vue?vue&type=script&lang=js&"
import style0 from "./tooltip2.vue?vue&type=style&index=0&id=a2335de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2335de8",
  null
  
)

export default component.exports